__turbopack_context__.v({
  "sponsorship_text": "sUywgG_sponsorship_text",
});
